var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

    CONFUSEDWEBSITE.responsiveTables = function () {

        var $cmsContentTables = $('.' + CSSCONSTANTS.cmsContentClass + ' table');

        $cmsContentTables.each(function () {
            var $thisTable = $(this),
                $thisTableHeadings = $thisTable.find('th');

            if (!$thisTable.hasClass('non-responsive-table')) {
                if ($thisTableHeadings.hasClass(CSSCONSTANTS.hideColumnOnMobileClass)) {
                    CONFUSEDWEBSITE.hideTableColumnsOnMobile($thisTable);
                }
                else if ($thisTableHeadings.hasClass(CSSCONSTANTS.hideColumnOnTabletAndMobileClass)) {
                    CONFUSEDWEBSITE.hideTableColumnsOnTabletAndMobile($thisTable);
                }
                else if ($thisTable.hasClass('tablet-responsive-table')) {
                    CONFUSEDWEBSITE.stackTableRows($thisTable);
                }
                else {
                    CONFUSEDWEBSITE.stackTableRows($thisTable,'mobile');
                }
            } 
        });

    };

    CONFUSEDWEBSITE.hideTableColumnsOnMobile = function ($table) {
        var $hiddenColumns = $table.find('.' + CSSCONSTANTS.hideColumnOnMobileClass),
            columnIndex = 0;

        $hiddenColumns.each(function () {
            var $this = $(this),
                columnIndex = $this.index() + 1;

            $this.addClass(CSSCONSTANTS.hiddenMobileOnlyClass);
            $table.find('tr').find('td:nth-child(' + columnIndex + ')').addClass(CSSCONSTANTS.hiddenMobileOnlyClass);
        });
    };

    CONFUSEDWEBSITE.hideTableColumnsOnTabletAndMobile = function ($table) {
        var $hiddenColumns = $table.find('.' + CSSCONSTANTS.hideColumnOnTabletAndMobileClass),
            columnIndex = 0;

        $hiddenColumns.each(function () {
            var $this = $(this),
                columnIndex = $this.index() + 1;

            $this.addClass(CSSCONSTANTS.hiddenTabletAndMobileClass);
            $table.find('tr').find('td:nth-child(' + columnIndex + ')').addClass(CSSCONSTANTS.hiddenTabletAndMobileClass);
        });
    };

    CONFUSEDWEBSITE.stackTableRows = function ($table,breakpoint) {
        var headings = [],
            $tableHeadings = $table.find('th'),
            $tableRows = $table.find('tbody').find('tr:not(.tr-footnote)');

        if (breakpoint === 'mobile') {
            $table.addClass(CSSCONSTANTS.responsiveTableVerticalClass);
        }

        $.each($tableHeadings, function () {
            var $thisHeading = $(this);
            headings.push($thisHeading.text());
        });

        $.each($tableRows, function () {
            var $thisRow = $(this),
                $tableCells = $thisRow.find('td'),
                n = 0;

            $.each($tableCells, function () {
                var $thisCell = $(this),
                    $thisCellHeading = $('<span>', {
                        text: headings[n],
                        'class': CSSCONSTANTS.fauxTableHeaderClass
                    });

                $thisCellHeading.prependTo($thisCell);
                n++;
            });
        });

    };

})(window.jQuery);